var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useAppState } from "./use-app-state";
import { usePathChangeEffect } from "./use-path-change-effect";
export var useEntityAnimateStateEffect = function (props) {
  var _a, _b;
  var _c = __read(useAppState(), 3),
    state = _c[0],
    setState = _c[1],
    patchState = _c[2];
  var entity = props.entity,
    componentId = props.componentId;
  var animatePath = "".concat(componentId, "-").concat(entity.path);
  var animate = (_a = state.animate) === null || _a === void 0 ? void 0 : _a[animatePath];
  usePathChangeEffect(entity.path, {
    hashChange: function () {
      var _a;
      console.log(state.animate);
      patchState({
        animate: __assign(__assign({}, state.animate || {}), (_a = {}, _a[animatePath] = false, _a))
      });
    }
  });
  return animate === undefined ? true : (_b = state.animate) === null || _b === void 0 ? void 0 : _b[animatePath];
};